module.exports = __webpack_public_path__ + "static/media/procedure_cn.07dd1443.jpg";